var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-table-column", {
    key: _vm.code,
    attrs: { label: _vm.name, fixed: false, align: "center", width: "300" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (scope) {
          return _vm._l(_vm.parseData(scope.row[_vm.code]), function (label) {
            return _c(
              "el-tag",
              { key: label.id, attrs: { size: "mini", type: "primary" } },
              [_vm._v(" " + _vm._s(label.name) + " ")]
            )
          })
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }